import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {enableSquareFootage, setSqftFromFeature, setSquareFootageGroup} from "../../../../../actions/sqftFunctions";
import {setCameFromPage} from "../../../../../actions/actionFunctions";
import {GroheSQFTIcon} from "../../../../common/icons";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {canShowSqftButtonForFeature, canShowSqftCabinetButtonForFeature} from "../../../../../misc/helpers";
import {SQFT_GROUP} from "../../../../sqft/constants";

const GroheFeatureSQFTButton = (props) => {

  const {featureOpened, shopPageOpened, setCameFromPage, setSqftFromFeature, className, isIcon, intl,
    fabricatorSettings, enableSquareFootage, setSquareFootageGroup} = props;

  if (featureOpened) {
    if (!canShowSqftButtonForFeature(featureOpened, fabricatorSettings) && !canShowSqftCabinetButtonForFeature(featureOpened, fabricatorSettings)) {
      return null
    }
  }

  const handleSQFTButtonClick = () => {
    Analytics.sendClickEvent(shopPageOpened
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.shopSQFTButton
      : PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureSQFT);
    if (featureOpened) {
      setSqftFromFeature({cartFeature: featureOpened});
      setCameFromPage(featureOpened);
    }
    // change url to get cabinets group
    // const sqftUrl = (featureOpened && canShowSqftCabinetButtonForFeature(featureOpened, fabricatorSettings))
    //   ? ROUTES.sqft + "?cabinets=1"
    //   : ROUTES.sqft
    // history.push(sqftUrl);

    // use redux to get cabinets group
    if (featureOpened && canShowSqftCabinetButtonForFeature(featureOpened, fabricatorSettings)) {
      setSquareFootageGroup(SQFT_GROUP.cabinets)
    }
    enableSquareFootage(true);
  };

  if (isIcon) {
    return (
      <IconButton aria-label={intl.formatMessage({id: "quotingTool.featureInfo.sqftButton"})}
                  className={"look-icon look-icon--gray look-icon--small2 " + (className || "")}
                  onClick={handleSQFTButtonClick}>
        <GroheSQFTIcon/>
      </IconButton>
    )
  }

  return (
    <Button className={"look-button look-button--10-radius look-button--42 look-button--secondary look-button--no-transform "
      + (className || "")}
            startIcon={<GroheSQFTIcon/>}
            onClick={handleSQFTButtonClick}>
      <FormattedMessage id="quotingTool.featureInfo.sqftButton"/>
    </Button>
  )
};

GroheFeatureSQFTButton.propTypes = {
  featureOpened: PropTypes.shape(featureInterface),
  className: PropTypes.string,
  isIcon: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {shopPageOpened} = store.shopState;
  const {settings} = store.fabricatorState;
  return {
    shopPageOpened,
    fabricatorSettings: settings,
  };
};

const mapDispatchToProps = {
  setCameFromPage,
  setSqftFromFeature,
  setSquareFootageGroup,
  enableSquareFootage,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheFeatureSQFTButton)
  )
)
